<template>
    <div>
        <el-table :data="tableData" border style="width: 100%"
            :header-cell-style="{ background: '#f2f2f2', color: '#000' }" @selection-change="handleSelectionChange">
            <el-table-column prop="createName" label="操作人" align="center" width="200" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createDate" label="操作时间" align="center"  :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="statusDesc" label="操作描述" align="center"  :show-overflow-tooltip="true">
            </el-table-column>
        </el-table>
        <!-- 0待派发 1待处理 2待回访 3服务完成 4待作废 5已作废 7.异常工单 -->
        <div style="height: 20px"></div>
    </div>
</template>
<script>
import request from "@/utils/request.js"
export default {
    props:{
        tableData:{
            type:Array,
            default:[]
        } 
    },
    data() {
        return {
            tableData: [],
        }
    },
    created() { },
    methods: {
        handleSelectionChange(){}  
       
    }
}
</script>
<style></style>